export default __webpack_public_path__ + "static/media/jpegIcon.6a907f33.svg";